import { useCallback } from "react";
import { type QueryClient, useQueryClient } from "@tanstack/react-query";
import {
	createVehicleQueryOptions,
	useVehicleQueryOptions,
} from "../../query-keys";
import type { Platform } from "@/types/platform.types";

/**
 * Hook version for use in components
 */
export function usePrefetchMyVehicles() {
	const queryClient = useQueryClient();
	const vehicleQueryOptions = useVehicleQueryOptions();

	return useCallback(
		() => queryClient.ensureQueryData(vehicleQueryOptions.myVehicles()),
		[queryClient, vehicleQueryOptions]
	);
}

/**
 * Static function for route loaders (outside React context)
 * Requires explicit platform parameter
 */
export async function prefetchMyVehicles({
	queryClient,
	platform,
}: {
	queryClient: QueryClient;
	platform: Platform;
}) {
	const vehicleQueryOptions = createVehicleQueryOptions(platform);
	return queryClient.ensureQueryData(vehicleQueryOptions.myVehicles());
}
